import React from 'react'
import AnimationWrapper from '../helpers/Animations'
import GalleryGrid from '../submodules/GalleryGrid'
import GalleryVideo from '../submodules/GalleryVideo'
import GalleryQuilt from '../submodules/GalleryQuilt'

const Gallery = ({ options }) => {
    let output = null
    switch (options.type) {
    case 'grid':
        output = <GalleryGrid options={options} />
        break
    case 'video':
        output = <GalleryVideo options={options} />
        break
    default: // This is a gallery of three "static" images, aka "a quilt"
        output = <GalleryQuilt options={options} />
        break
    }
    return (
        <AnimationWrapper type='fade-up'>
            {output}
        </AnimationWrapper>
    )
}

export default Gallery
